import { Box, Button, Editable, EditableInput, EditablePreview, Flex, FormLabel, Input, ScaleFade, Text, useClipboard } from '@chakra-ui/react'
import React from 'react'
import { DataContext } from '../../../state/DataContext/DataContext';

export default function Team() {
    const [value, setValue] = React.useState("")
    const { data, actions } = React.useContext(DataContext);
    const { hasCopied, onCopy } = useClipboard(value)

    React.useEffect(() => {
        setValue(`localhost:3000/${data.tenantID}/signup`)
    }, [data])

    return (
        <ScaleFade key="Team" initialScale={0.1} in>
            <Box maxW="600px" m="auto" bg="white" boxShadow="md" p="4" borderRadius="md">
                <FormLabel htmlFor="CustomerName">Team Invite Link</FormLabel>
                <Flex mb={2}>
                    <Input bg="white" borderRadius="0.2em" value={value} isReadOnly placeholder="Welcome" />
                    <Button borderRadius="0.2em" onClick={onCopy} ml={2}>
                        {hasCopied ? "Copied" : "Copy"}
                    </Button>
                </Flex>
                <Text fontSize="0.8em">Your employees will signup to your workspace through this link. Once registered, you can assign task and track their work and access any files/photo they upload. </Text>

            </Box>
        </ScaleFade>
    )
}
